<template>
    <footer id="footer">
        <div class="container">
            <ul class="icons">
                <li><a href="#" class="icon fa-twitter"><span class="label">Twitter</span></a></li>
                <li><a href="#" class="icon fa-facebook"><span class="label">Facebook</span></a></li>
                <li><a href="#" class="icon fa-instagram"><span class="label">Instagram</span></a></li>
                <li><a href="#" class="icon fa-envelope-o"><span class="label">Email</span></a></li>
            </ul>
        </div>
        <div class="copyright">
            &copy; Untitled. All rights reserved.
        </div>
    </footer>
</template>

<script>
export default {
    
}
</script>

<style scoped>
#footer {
    padding: 4rem 0 2rem 0 ;
    background: #000;
    text-align: center;
}

    #footer a {
        color: rgba(255, 255, 255, 0.5);
    }

        #footer a:hover {
            color: #FFF;
        }

    #footer .copyright {
        color: #bbb;
        font-size: 0.9rem;
        margin: 0 0 2rem 0;
        padding: 0;
        text-align: center;
    }

    @media screen and (max-width: 736px) {

        #footer {
            padding: 3rem 0 1rem 0 ;
        }

    }
</style>